import getApiUrl from 'src/config/api';
import ApiError from 'src/utils/error';
import { ACTION_TYPES } from './constants';

export const fetchCatalog = ({ pageSize, pageNumber } = { pageSize: 100, pageNumber: 1 }) => async (dispatch) => {
    await fetch(`${getApiUrl()}/api/client/cities?pageSize=${pageSize}&pageNumber=${pageNumber}`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    }).then((response) => {
        if (response.ok) {
            return response.json();
        } else {
            return response.json().then((json) => { throw new ApiError(json); });
        }
    }).then((response) => {
        dispatch({
            type: ACTION_TYPES.CATALOG_FETCHED,
            payload: response.cities
        });
    }).catch(() => {
        dispatch({
            type: ACTION_TYPES.CATALOG_FETCHED,
            payload: []
        });
    });
};

export const fetchCityCatalog = (name, { pageSize, pageNumber } = { pageSize: 100, pageNumber: 1 }) => async (dispatch) => {
    await fetch(`${getApiUrl()}/api/client/cities/${name}?pageSize=${pageSize}&pageNumber=${pageNumber}`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    }).then((response) => {
        if (response.ok) {
            return response.json();
        } else {
            return response.json().then((json) => { throw new ApiError(json); });
        }
    }).then((response) => {
        dispatch({
            type: ACTION_TYPES.CITY_CATALOG_FETCHED,
            payload: { name, catalog: response.restaurantNames }
        });
    }).catch(() => {
        dispatch({
            type: ACTION_TYPES.CITY_CATALOG_FETCHED,
            payload: { name, catalog: null }
        });
    });
};
